import React from 'react';
import { Fieldset, FormNumber } from '~/components/FormControl';
import { formLabel } from '~/utils/helpers';
import { Form } from 'react-bootstrap';

function DiceAndPoint() {
    return (
        <Fieldset className={'px-2'}>
            <Fieldset.Legend>{formLabel('DiceAndPoint')}</Fieldset.Legend>
            <Form.Row>
                <FormNumber
                    name="dvSet"
                    sm={3}
                />
                <FormNumber
                    name="dvAdded"
                    sm={3}
                />
                <FormNumber
                    name="dvDeducted"
                    sm={3}
                />
                <FormNumber
                    name="pointToPay"
                    sm={3}
                />
            </Form.Row>
        </Fieldset>
    );
}

export default DiceAndPoint;
